<template>
  <section id="pagination-section" class="SanitasPagination type-detailed">
    <ul>
      <li
        v-for="(pageNumber, i) in totalPages"
        :key="i"
        class="pager__number"
        :class="pageNumber === currentPage + 1 ? 'is-active' : ''"
        @click="$emit('goToPage', pageNumber - 1)"
      >
        <a>
          <span>{{ pageNumber }}</span>
        </a>
      </li>

      <li class="pagination__navigation">
        <span
          class="pagination__prev"
          :class="{ disabled: currentPage === 0 }"
          @click="$emit('goToPrevPage')"
        >
          <dotcom-icon name="chevron-down" art="solid" rotation="90" />
        </span>

        <span
          class="pagination__next"
          :class="{ disabled: currentPage === totalPages - 1 }"
          @click="$emit('goToNextPage')"
        >
          <dotcom-icon name="chevron-down" art="solid" rotation="270" />
        </span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Pagination',

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    totalPages: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style>
.SanitasPagination {
  display: flex;
  align-items: center;

  .pager__label {
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    line-height: 1.35;
    color: var(--c-primary-neutral-1);
    margin-right: 10px;
  }

  a {
    text-decoration: none;
  }

  ul {
    display: flex;
    margin: 0;
    padding: 0;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    li {
      list-style: none;
      display: inherit;

      &.is-active span {
        color: var(--c-primary-color-2);
        font-weight: 700;
      }

      span {
        font-weight: 400;
        font-style: normal;
        font-size: 13px;
        line-height: 1.35;
        color: var(--c-secondary-neutral-2);
        text-decoration: none;
      }

      a:hover {
        border: none;
      }
    }
  }

  .pager__number {
    cursor: pointer;
    &:hover {
      span {
        color: var(--c-primary-color-3);
      }
    }
  }

  .pagination__navigation {
    display: flex;
    gap: 10px;
  }

  .pagination__next,
  .pagination__prev {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--c-primary-neutral-3);
    font-size: 16px;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    border: 1px solid var(--c-secondary-neutral-2);
    color: var(--c-secondary-neutral-2);
    cursor: pointer;
    outline: none;

    &:hover {
      background-color: var(--c-primary-color-3);
      border-color: var(--c-primary-color-3);
      color: var(--c-primary-neutral-3);
    }

    &.disabled {
      cursor: not-allowed;

      &:hover {
        background-color: initial;
        color: var(--c-secondary-neutral-2);
        border-color: var(--c-secondary-neutral-2);
      }
    }
  }
}

#pagination-section {
  justify-content: flex-end;
  margin-top: 10px;

  li:last-of-type {
    margin-right: 0;
  }
}
</style>
